import { TextField } from "@mui/material"
import { ChangeEventHandler, FC } from "react"
import { Control, Controller } from "react-hook-form"

interface InputFieldWrapperProps {
  name: string
  placeholder: string

  type?: string
  label?: string
  multiline?: boolean
  rows?: number
  size?: "small" | "medium"
  margin?: "dense" | "normal" | "none"

  value?: string | null
  required?: boolean
  onChange?: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
  control?: Control<any, any>
  rules?: any
  helperText?: any
  "data-testid"?: string
}

export const InputFieldWrapper: FC<InputFieldWrapperProps> = ({
  type = "text",
  label = "",
  value = undefined,
  multiline = false,
  rows = 1,
  size = "medium",
  margin = "normal",
  control = null,
  ...props
}) => {
  /* TODO: Add common props component  */
  if (control) {
    return (
      <Controller
        name={props.name}
        control={control}
        rules={props.rules}
        render={({
          field: { onChange, onBlur, value, ref },
          fieldState: { error },
        }) => (
          <TextField
            {...props}
            fullWidth
            // focused
            size={size}
            type={type}
            label={label}
            margin={margin}
            variant="outlined"
            multiline={multiline}
            rows={rows}
            value={value}
            onChange={(event) => {
              let value: string | number = event.target.value
              if (type === "number") {
                value = Number(value)
              }
              onChange(value)
            }}
            onBlur={onBlur}
            inputRef={ref}
            error={!!error}
            helperText={error ? error.message : props.helperText}
          />
        )}
      />
    )
  }

  return (
    <TextField
      {...props}
      fullWidth
      // focused
      size={size}
      type={type}
      label={label}
      value={value || ""}
      margin={margin}
      variant="outlined"
      multiline={multiline}
      rows={rows}
    />
  )
}
